<template>
	<section class="guide container">
		<div class="guide__Wrapper">
			<div class="guide__Item" v-for="item in data">
				<FlickitySlider class="guide__ItemGallery">
					<Flare
						v-for="image in item.gallery"
						:srcset="image"
						size="both"
						width="840"
						height="600"
						crop="fill"
						:alt="image.title ||''" />
				</FlickitySlider>
				<div class="guide__ItemContent">
					<h2 v-text="item.title" />
					<div class="guide__ItemRichText" v-html="item.rich_text" />
				</div>
			</div>
		</div>

		<div v-if="page?.description_end" class="guide__DescriptionEnd richText container--Small" v-html="page.description_end" />
	</section>
</template>

<script setup>
	const { page } = usePage();
	defineProps({
		data: {},
	});
</script>

<style lang="scss">
	@import url('@/assets/styles/components/blocks/_guide.scss');
</style>
